module.exports = __webpack_public_path__ + "img/totalDuration.e283451a.svg";